'use strict';

exports.__esModule = true;
exports.isSelectorMapEqual = isSelectorMapEqual;
exports.parseQuery = parseQuery;

var _DataStructure = require('./DataStructure');

/**
 * Test if two classMap object are the same
 *
 * @param {Object|null} a A plain JS object, with string as key, boolean as value
 * @param {Object|null} b Same as a
 *
 * @return {boolean} True if a and b have the same key and mapped value,
 *                   or both are null.
 */
function isSelectorMapEqual(a, b) {
  if (a === b) {
    return true;
  } else if (a === null || b === null) {
    return false;
  }

  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);

  if (aKeys.length !== bKeys.length) {
    return false;
  }

  for (var _iterator = aKeys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var key = _ref;

    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}

/**
 * A curried function. Take query defination and size object,
 * return a selectorMap by testing size against rules in query defination
 *
 * @param {Object} query Object contains container query break points
 * @param {Object} size  With width and height property
 *
 * @return {Object} A map of selector to boolean
 */
function parseQuery(query) {
  var rules = [];

  for (var _iterator2 = (0, _DataStructure.toPairs)(query), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref2 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref2 = _i2.value;
    }

    var _ref6 = _ref2;
    var selectorName = _ref6[0];
    var _ref6$ = _ref6[1];
    var minWidth = _ref6$.minWidth;
    var maxWidth = _ref6$.maxWidth;
    var minHeight = _ref6$.minHeight;
    var maxHeight = _ref6$.maxHeight;

    rules.push([selectorName, {
      minWidth: minWidth || 0,
      maxWidth: maxWidth || Infinity,
      minHeight: minHeight || 0,
      maxHeight: maxHeight || Infinity
    }]);
  }

  return function (_ref3) {
    var width = _ref3.width;
    var height = _ref3.height;

    var selectorMap = {};

    for (var _iterator3 = rules, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref4;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref4 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref4 = _i3.value;
      }

      var _ref5 = _ref4;
      var selectorName = _ref5[0];
      var _ref5$ = _ref5[1];
      var minWidth = _ref5$.minWidth;
      var maxWidth = _ref5$.maxWidth;
      var minHeight = _ref5$.minHeight;
      var maxHeight = _ref5$.maxHeight;

      selectorMap[selectorName] = minWidth <= width && width <= maxWidth && minHeight <= height && height <= maxHeight;
    }

    return selectorMap;
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-container-query/lib/containerQuery.js
 ** module id = 114
 ** module chunks = 0
 **/